import { serverLang } from '@/composables/locale'

export default defineNuxtPlugin(async ({ hook }) => {
  const i18n = useI18n()
  const cachedLang: Record<string, true> = {}

  async function i18nReg(
    _register: (translations: unknown, locale?: string) => void,
    locale: string,
  ): Promise<void> {
    if (cachedLang[locale]) {
      return
    }

    const config = useRuntimeConfig()
    const host = getHost(config)
    let urlApi = `https://${host}/js/lang/${locale}.json`
    if (import.meta.server && !config.public.isDev) {
      urlApi = `http://${config.public.serverHost}/js/lang/${locale}.json`
    }

    const translatesRaw = await fetch(urlApi)
    if (translatesRaw.status >= 500) {
      console.error(`TRANSLATE REQ CHECKER ERROR ${translatesRaw.status}`, urlApi)
      process?.exit?.(1)
    }
    try {
      const translations = await translatesRaw.json()

      if (translations) {
        serverLang[locale] = translations

        // Merge translations after hydration, because before onNuxtReady missmatch hydration causes server version stall
        onNuxtReady(() => {
          i18n.$mergeTranslations({
            ...translations,
          })
        })

        cachedLang[locale] = true
      }
    } catch (error) {
      console.error(`TRANSLATE CHECKER ERROR ${translatesRaw.status}`, urlApi, error)
      process?.exit?.(1)
    }
  }

  hook('i18n:register' as 'app:beforeMount', i18nReg as unknown as () => void)

  await i18nReg((_translations) => undefined, i18n.getLocale() ?? 'en')
})
